import React__default, { createContext } from "react";
let e = createContext(() => {
});
function C({ value: t, children: o }) {
  return React__default.createElement(e.Provider, { value: t }, o);
}
export {
  C as CloseProvider
};
